import React from 'react';
import CellContent from '../../../shared/ui/CellContent/CellContent';
import { columnKeyMap } from '../../../shared/constants/columnKeyMap';
import { Icon, Tooltip } from 'antd';
import moment from 'moment';
import BtnPermitActions from '../../../shared/ui/BtnPermitActions/BtnPermitActions';
import { permitConstants } from '../../../../../constants/permit.constants';

const {
  clientFio,
  permitStatus,
  permitType,
  insertDate,
  entryDate,
  expireDate,
  number,
  isRepeatPermit,
  brand,
  houseNamePermit,
} = columnKeyMap;

export const getTableColumns = ({
  sortedInfo,
  sortMode,
  handleSortMode,
  onSuccessActions,
}) => [
  {
    title: 'Тип',
    key: permitType,
    dataIndex: permitType,
    colSpan: 1,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === permitType && sortedInfo?.order,
    render: (value) => (
      <CellContent topRowContent={value ? value : 'Нет'} isHighlighted />
    ),
  },
  {
    title: 'Статус',
    key: permitStatus,
    dataIndex: permitStatus,
    colSpan: 1,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === permitStatus && sortedInfo?.order,
    render: (value) => (
      <CellContent topRowContent={value ? value : 'Нет'} isHighlighted />
    ),
  },
  {
    title: 'ТС',
    key: brand,
    dataIndex: brand,
    colSpan: 1,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === brand && sortedInfo?.order,
    render: (value, permit) => (
      <CellContent
        topRowContent={`${value} ${permit?.transport?.model}`}
        isWhite
      />
    ),
  },
  {
    title: 'Номер ТС',
    key: number,
    dataIndex: number,
    colSpan: 1,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === number && sortedInfo?.order,
    render: (value, permit) => (
      <CellContent
        topRowContent={`${value} ${permit?.transport?.region}`}
        isWhite
      />
    ),
  },
  {
    title: 'Клиент заявитель',
    key: clientFio,
    dataIndex: clientFio,
    colSpan: 1,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === clientFio && sortedInfo?.order,
    render: (value, permit) => (
      <CellContent
        topRowContent={value || permit?.name || 'Нет данных'}
        isHighlighted
      />
    ),
  },
  {
    title: 'Адрес клиента заявителя',
    key: houseNamePermit,
    dataIndex: houseNamePermit,
    colSpan: 1,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === houseNamePermit && sortedInfo?.order,
    render: (value, permit) => (
      <CellContent
        topRowContent={`${permit?.houseName}, кв.${permit?.addressName}`}
        isHighlighted
      />
    ),
  },
  {
    title: 'Дата создания',
    key: insertDate,
    dataIndex: insertDate,
    colSpan: 1,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === insertDate && sortedInfo?.order,
    render: (value) => (
      <CellContent
        topRowContent={value ? moment(value).format('DD.MM.YYYY') : '-'}
        isHighlighted
      />
    ),
  },
  {
    title: (
      <div>
        <span>Даты действия пропуска</span>
        <Tooltip title="По дате окончания временного пропуска">
          <Icon
            onClick={(e) => {
              sortMode?.mode !== expireDate
                ? handleSortMode({ mode: expireDate, columnKey: entryDate })
                : handleSortMode({ mode: null, columnKey: null });
            }}
            style={{
              cursor: 'pointer',
              color: sortMode?.mode !== expireDate ? '#afafaf' : '#0995ed',
              marginLeft: 10,
            }}
            type="close-square"
          />
        </Tooltip>
      </div>
    ),
    key: entryDate,
    dataIndex: entryDate,
    colSpan: 1,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === entryDate && sortedInfo?.order,
    render: (value, permit) => {
      return (
        <CellContent
          topRowContent={moment(permit.startDate).format(
            permit?.permitType?.id === permitConstants.ONE_TIME_PASS
              ? 'DD.MM.YYYY HH:mm'
              : 'DD.MM.YYYY'
          )}
          bottomRowContent={
            !!permit?.expireDate
              ? moment(permit.expireDate).format(
                  permit?.permitType?.id === permitConstants.ONE_TIME_PASS
                    ? 'DD.MM.YYYY HH:mm'
                    : 'DD.MM.YYYY'
                )
              : ''
          }
          topRowTitle="Дата начала действия пропуска"
          bottomRowTitle={
            !!permit?.expireDate
              ? `Дата окончания действия ${
                  permit?.permitType?.id === permitConstants.ONE_TIME_PASS
                    ? 'одноразового'
                    : 'временного'
                } пропуска`
              : ''
          }
        />
      );
    },
  },
  {
    title: 'Повторный',
    key: isRepeatPermit,
    dataIndex: isRepeatPermit,
    colSpan: 1,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === isRepeatPermit && sortedInfo?.order,
    render: (value) => (
      <CellContent topRowContent={value ? 'Да' : 'Нет'} isWhite />
    ),
  },
  {
    key: 'actions',
    colSpan: 1,
    align: 'right',
    render: (_, permit) => (
      <BtnPermitActions onSuccess={onSuccessActions} permit={permit} />
    ),
  },
];
